import _ from "lodash";

export const computePayrollPaymentBreakdown = ({
  payrollBids,
  bids,
  total,
  totalSelf,
}) => {
  const usePayrollBids = Array.isArray(payrollBids) && payrollBids.length > 0;
  const items = usePayrollBids ? payrollBids : bids || [];
  const fallbackTotal = totalSelf ?? total ?? 0;

  if (!items.length || (usePayrollBids && typeof items[0] !== "object")) {
    return {
      pendingAmount: fallbackTotal,
      holdAmount: 0,
      settledAmount: 0,
      totalAmount: fallbackTotal,
    };
  }

  const amountOf = (bid) =>
    usePayrollBids ? bid.commissionAmount || 0 : bid.paidAmount || 0;

  let pendingAmount = 0;
  let holdAmount = 0;
  let settledAmount = 0;

  for (const bid of items) {
    if (bid.status === "CANCEL") continue;
    const amount = amountOf(bid);
    if (bid.status === "HOLD") {
      holdAmount += amount;
    } else if (bid.status === "SETTLED") {
      settledAmount += amount;
    } else {
      pendingAmount += amount;
    }
  }

  const totalAmount = pendingAmount + holdAmount + settledAmount;

  return {
    pendingAmount: _.round(pendingAmount, 2),
    holdAmount: _.round(holdAmount, 2),
    settledAmount: _.round(settledAmount, 2),
    totalAmount: _.round(totalAmount, 2),
  };
};
